/* import __COLOCATED_TEMPLATE__ from './logical-mode.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import { equal } from '@ember/object/computed';
import Component from '@ember/component';
export default Component.extend({
  isVertical: false,
  shouldDisplayLogicalMode: equal('logicalMode', 'or'),
  classNames: ['predicates__logical-mode__wrapper'],
  classNameBindings: ['isVertical:o__is-vertical']
});